import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

type BrandLockupProps = {
  to?: string;
  align?: "start" | "center";
  tone?: "primary" | "neutral";
  className?: string;
  titleClassName?: string;
  subtitleClassName?: string;
};

export function BrandLockup({
  to = "/",
  align = "start",
  tone = "primary",
  className,
  titleClassName,
  subtitleClassName,
}: BrandLockupProps) {
  const titleTone = tone === "primary" ? "text-primary" : "text-slate-950";
  const subtitleTone = tone === "primary" ? "text-slate-500" : "text-slate-500";

  return (
    <Link
      to={to}
      className={cn(
        "inline-flex flex-col leading-none transition-opacity hover:opacity-80",
        align === "center" ? "items-center text-center" : "items-start text-start",
        className,
      )}
      aria-label="Athr Campus home"
    >
      <span className={cn("font-display text-xl font-bold tracking-tight", titleTone, titleClassName)}>
        Athr
      </span>
      <span
        className={cn(
          "mt-1 text-[10px] font-semibold uppercase tracking-[0.28em]",
          subtitleTone,
          subtitleClassName,
        )}
      >
        Campus
      </span>
    </Link>
  );
}
